import { Navigate, useLocation } from 'react-router-dom';

import { useAppState } from '../contexts/AppContext';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

export function Protected({ children }: ProtectedRouteProps) {
  const { authState } = useAppState();
  const location = useLocation();

  if (!authState.loggedIn) {
    // `search` is carried across, because Cognito returns to `/?code=…&state=…` and this redirect
    // runs BEFORE the bootstrap effect exchanges the code — `loggedIn` is false on that first
    // render by definition. A bare `to="/login"` carries no search component, so the redirect
    // replaced the URL and destroyed the authorization code, and the exchange then found nothing
    // to exchange: the login screen with no error, no token request, and an empty console.
    return <Navigate to={{ pathname: '/login', search: location.search }} replace />;
  }

  return <>{children}</>;
}
